import MetaData from  '../../../mixins/meta-data.js'
export default {
	
}


// WEBPACK FOOTER //
// ./src/components/pages/page-not-found/page-not-found.js